module.exports = __webpack_public_path__ + "d84837c95678744cadc6566f04798b49.pdf";